import React from "react"
import PropTypes from "prop-types"

// D3
import { line } from "d3-shape"
import { scaleLinear } from "d3-scale"

// Components
import LineViz from "./LineViz"

const Line = props => {
  const { data, xScale, yScale, xKey, yKey, colorArr } = props

  if (data.length) {
    // Line Data
    const lineSetup = line()
      .x(d => xScale(d[xKey]))
      .y(d => yScale(d[yKey]))
    const scoreLine = lineSetup(data)

    // Color Gradient Data
    const offsets = colorArr.map((color, i) => ({
      offset: `${Math.ceil(((i + 1) / colorArr.length) * 100)}%`,
      color
    }))
    // Endpoint Data
    const finalX = data[data.length - 1].month
    const finalY = data[data.length - 1].score
    const scaledFinalX = xScale(finalX)
    const scaledFinalY = yScale(finalY)

    // Viz Props
    const vizProps = {
      scoreLine,
      offsets,
      finalY,
      scaledFinalX,
      scaledFinalY,
      ...props
    }

    return <LineViz {...vizProps} />
  }
  return null
}

export default Line

Line.propTypes = {
  classes: PropTypes.string,
  translate: PropTypes.string,
  colorArr: PropTypes.arrayOf(PropTypes.string),
  color: PropTypes.string,
  showEndScore: PropTypes.bool,
  data: PropTypes.arrayOf(
    PropTypes.shape({
      month: PropTypes.object,
      score: PropTypes.number
    })
  ),
  xScale: PropTypes.func,
  yScale: PropTypes.func,
  xKey: PropTypes.string,
  yKey: PropTypes.string,
  gradientId: PropTypes.string
}

Line.defaultProps = {
  classes: "line",
  translate: "translate(0, 0)",
  colorArr: ["black"],
  color: "black",
  xScale: scaleLinear()
    .domain([0, 0])
    .range([0, 0]),
  yScale: scaleLinear()
    .domain([0, 0])
    .range([0, 0]),
  showEndScore: true,
  data: [{ date: new Date(), trainees: 0, score: 0 }],
  xKey: "date",
  yKey: "score",
  gradientId: "line-gradient"
}
